import usePageTitle from '@/hooks/use-page-title';
import { Link } from 'react-router-dom';
import { ChevronRight, Phone, Clock, Lightbulb, AlertTriangle } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';

const Assistance = () => {
    usePageTitle('Assistance');
    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="space-y-2 sm:space-y-3 mt-4">
                <nav className="flex items-center gap-1.5 text-xs sm:text-sm text-muted-foreground" aria-label="Fil d'Ariane">
                    <Link to="/" className="hover:text-foreground transition-colors no-underline">Mon espace</Link>
                    <ChevronRight className="w-3.5 h-3.5" />
                    <span>Assistance</span>
                </nav>
                <h1 className="text-xl sm:text-2xl font-bold">Assistance</h1>
            </div>

            {/* Hero */}
            <div className="relative overflow-hidden rounded-2xl bg-destructive p-6 text-white">
                <div className="absolute -top-1/2 -right-[10%] w-[400px] h-[400px] bg-white/10 rounded-full" />
                <div className="relative z-10">
                    <div className="flex items-center gap-2 mb-2">
                        <AlertTriangle className="w-5 h-5 sm:w-6 sm:h-6" />
                        <p className="text-xs sm:text-sm opacity-90 uppercase tracking-wide font-medium">Urgence</p>
                    </div>
                    <h2 className="text-xl sm:text-3xl font-semibold mb-2">En cas de panne ou d'accident</h2>
                    <p className="text-sm sm:text-base opacity-90">Contactez notre partenaire d'assistance, disponible 24h/24 et 7j/7.</p>
                </div>
            </div>

            {/* Contact Card */}
            <Card>
                <CardHeader className="pb-6 border-b">
                    <CardTitle className="text-lg flex items-center gap-2">
                        <Phone className="w-5 h-5 text-primary" />
                        Mondial Assistance
                    </CardTitle>
                </CardHeader>
                <CardContent className="pt-6">
                    <div className="flex flex-col sm:flex-row items-center gap-6">
                        <img
                            src="https://www.april-moto.com/wp-content/uploads/2021/05/logo-rouge-sur-blanc-format-jpg-1-700x278.jpg"
                            alt="Mondial Assistance"
                            className="w-40 sm:w-48 object-contain"
                        />
                        <div className="flex-1 text-center">
                            <a
                                href="tel:0149936582"
                                className="inline-flex items-center gap-3 px-6 py-6 bg-primary/5 border border-primary/20 rounded-xl no-underline hover:bg-primary/10 transition-colors"
                            >
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10">
                                    <Phone className="w-6 h-6 text-primary" />
                                </div>
                                <div>
                                    <p className="text-2xl sm:text-3xl font-bold text-primary">01 49 93 65 82</p>
                                    <div className="flex items-center gap-1 text-sm text-muted-foreground justify-center sm:justify-start">
                                        <Clock className="w-3.5 h-3.5" />
                                        24h/24 - 7j/7
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </CardContent>
            </Card>

            {/* Astuce */}
            <Alert variant="warning">
                <Lightbulb className="h-4 w-4" />
                <AlertDescription>
                    <strong>Astuce :</strong> Ajoutez ce numéro dans les contacts de votre téléphone pour le retrouver plus rapidement.
                </AlertDescription>
            </Alert>

            {/* Disclaimer */}
            <p className="text-xs text-muted-foreground">
                * Selon les garanties souscrites sur votre contrat d'assurance.
            </p>
        </div>
    );
};

export default Assistance;
